module.exports = __webpack_public_path__ + "media/pt_pt_s3_Miguel.20667cb6.oga";